






















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class RkBack extends Vue {
  @Prop({ default: '' }) private size!: string;
  private handleBack() {
    const query = this.$route.query as any;
    if (query.form) {
      this.$router.push(query.form);
    } else {
      this.$emit('back');
    }
  }
}
